var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.41 29.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.36,
    y1: 18.45,
    x2: 35.65,
    y2: 18.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47694"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.86,29.82c3.72-5.37,8.39-5.09,10.87-4.54s1.92-1.1,1.92-1.1a6.09,6.09,0,0,1,3-7.43c1.93-1.1.55-2.06.55-2.06-4.54-2.34-4.26-6-3.85-7.43s-.69-1.37-.69-1.37a43.66,43.66,0,0,1-6.05,0c-3.71-.69-6.05-4.54-6.05-4.54-.83-1.38-1.51,0-1.51,0a10,10,0,0,1-6,4.4c-1.24.14-5.78,0-5.78,0s-1.1,0-.69,1.38.83,5.08-3.85,7.42c0,0-1.24,1.1.55,2.06a6.08,6.08,0,0,1,3,7.43s-.55,1.65,1.92,1.1,7.15-.69,10.87,4.54C17.21,29.82,18,31.05,18.86,29.82Z",
    transform: "translate(-0.29 -0.74)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.41,18.54V11.8h2.2a4.63,4.63,0,0,1,1.65.14,1.58,1.58,0,0,1,1,.69A2.06,2.06,0,0,1,13.64,14a2.54,2.54,0,0,1-.28,1.1,1.31,1.31,0,0,1-.55.69,1.39,1.39,0,0,1-.68.27c-.28,0-.83.14-1.38.14h-1v2.48H8.41ZM9.79,12.9v1.93h.69c.55,0,1,0,1.1-.14s.27-.14.41-.28.14-.27.14-.55a.72.72,0,0,0-.28-.55A.73.73,0,0,0,11.3,13H9.79Z",
    transform: "translate(-0.29 -0.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.74,18.54V11.8h2.89a4.22,4.22,0,0,1,1.51.14,1.8,1.8,0,0,1,.82.69,2.51,2.51,0,0,1,.28,1.1A1.67,1.67,0,0,1,19.83,15a2.58,2.58,0,0,1-1.38.69,3,3,0,0,1,.69.55c.14.14.41.55.82,1.1l.83,1.38H19.14l-1-1.52c-.42-.55-.55-.82-.69-1s-.28-.27-.41-.27a6.28,6.28,0,0,0-.69-.14h-.28v2.75Zm1.37-3.85h1c.68,0,1.1,0,1.23-.14s.28-.14.42-.27.13-.28.13-.55,0-.42-.13-.55a.72.72,0,0,0-.55-.28H16.11Z",
    transform: "translate(-0.29 -0.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.34,15.24a6.85,6.85,0,0,1,.28-1.79,4,4,0,0,1,.68-1,2.84,2.84,0,0,1,.83-.55,4.83,4.83,0,0,1,1.51-.28,2.84,2.84,0,0,1,2.34,1,3.76,3.76,0,0,1,1,2.61,3.35,3.35,0,0,1-.82,2.47,3.48,3.48,0,0,1-4.82,0A3,3,0,0,1,21.34,15.24Zm1.38,0A2.33,2.33,0,0,0,23.27,17a1.76,1.76,0,0,0,1.37.55A1.79,1.79,0,0,0,26,17a2.37,2.37,0,0,0,.55-1.79A2.34,2.34,0,0,0,26,13.45a1.62,1.62,0,0,0-1.38-.55,1.76,1.76,0,0,0-1.37.55A2.3,2.3,0,0,0,22.72,15.24Z",
    transform: "translate(-0.29 -0.74)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProRed);
export default __webpack_public_path__ + "static/media/pro-red.547b3aa51cee3cfaeade079747a9746b.svg";
export { ForwardRef as ReactComponent };